module.exports = __webpack_public_path__ + "static/media/mic-check-1.5d4fad72.png";